export default "__VITE_ASSET__B80o5uMg__"